import React from 'react';

import { StackingLayout as PrismUIStackingLayout } from '@nutanix-ui/prism-reactjs';
import type { StackingLayoutProps as PrismUIStackingLayoutProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Layouts/StackingLayout';

export type StackingLayoutProps = PrismUIStackingLayoutProps;

export default function StackingLayout(props: React.PropsWithChildren<StackingLayoutProps>) {
  return <PrismUIStackingLayout {...props} />;
}
